import { useState } from "react";
import { CountryOption } from "../utils/types";
import FlagIconCDN from "../../../../../../../../../../components/FlagIconCDN/FlagIconCDN";
import CrossIcon from "../../../../../../../../../../assets/svg/cross-icon";

interface ChipsListProps {
  ids: string[];
  transformedOptions: CountryOption[];
  onRemove: (id: string) => void;
  chipClassName?: string;
  isFlagIcon?: boolean;
  Icon?: React.ElementType;
  iconClassName?: string;
}

export const ChipsList = ({
  ids,
  transformedOptions,
  onRemove,
  chipClassName,
  isFlagIcon,
  Icon,
  iconClassName,
}: ChipsListProps) => {
  const [hoveredCountryId, setHoveredCountryId] = useState<string | null>(null);

  const handleCountryRemove = (id: string) => {
    setHoveredCountryId(null);
    onRemove(id);
  };

  const selectedOption = (id: string) =>
    transformedOptions?.find((country) => country?.value === id);
  return (
    <>
      {ids?.length > 0 && (
        <div className="flex items-center flex-wrap gap-1">
          {ids?.map((id) => (
            <div
              key={id}
              className={`h-[22px] flex items-center gap-x-0.5 pl-1 border hover:bg-hover-effect dark:hover:bg-hover-effect-dk rounded-md cursor-pointer ${
                hoveredCountryId === id ? "pr-1.5" : "pr-2"
              } ${chipClassName}`}
              onMouseEnter={() => {
                setHoveredCountryId(id);
              }}
              onMouseLeave={() => {
                setHoveredCountryId(null);
              }}
            >
              <div className="flex items-center gap-x-1">
                {isFlagIcon && (
                  <FlagIconCDN
                    code={selectedOption(id)?.flag || ""}
                    flagIconClassName="w-[18px] h-[14px] shrink-0 border border-gray-75 dark:border-gray-75-dk rounded-[2px]"
                  />
                )}
                {Icon && <Icon className={iconClassName} />}
                <span className="text-heading-text dark:text-heading-text-dk text-sm font-medium">
                  {selectedOption(id)?.content}
                </span>
              </div>
              {hoveredCountryId === id && (
                <button
                  className="text-heading-text dark:text-heading-text-dk"
                  onClick={() => handleCountryRemove(id)}
                >
                  <CrossIcon className="w-[14px] h-[14px] text-verba-red-alert dark:text-verba-red-alert-dk" />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};
